import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserDemoComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from './scenes/MainScene';

interface PhaserLandscapeDemoProps {
}

interface PhaserLandscapeDemoState {
}

const DemoConfig: GameConfig = {
    title: "Landscaping Demo",
    version: "0.9.3",
    backgroundColor: "#d3d3d3"
};

class PhaserLandscapeDemo extends React.Component<PhaserLandscapeDemoProps, PhaserLandscapeDemoState> {
    private Demo: Phaser.Game;
    constructor(props: PhaserLandscapeDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserLandscapeDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserDemoComponent scenes={MainScene} config={DemoConfig} />
        </div>);
    }
}

export default PhaserLandscapeDemo;



// WEBPACK FOOTER //
// ./src/games/demos/LandscapingDemo/Main.tsx